import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
const AuthCallback = () => {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || '';
    const params = new URLSearchParams(hash.substring(1));
    const sessionId = params.get('session_id');

    const finish = (user) => {
      window.history.replaceState(null, '', window.location.pathname);
      navigate('/profile', { replace: true, state: user ? { user } : undefined });
    };

    if (!sessionId) {
      finish(null);
      return;
    }

    fetch(`${BACKEND_URL}/api/auth/session`, {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ session_id: sessionId }),
    })
      .then(async (res) => finish(res.ok ? await res.json() : null))
      .catch(() => finish(null));
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#fafafa]" data-testid="auth-callback-loading">
      <div className="text-center">
        <div className="w-10 h-10 border-4 border-blue-600 border-t-transparent rounded-full animate-spin mx-auto mb-4" />
        <p className="text-gray-600 text-sm">Signing you in...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
